export function resolveRealm(): string | undefined {
  return new URLSearchParams(window.location.search).get('realm') ?? undefined;
}
